export default "__VITE_ASSET__DCzqCuw1__"